module.exports = __webpack_public_path__ + "static/media/02A.f7e291c4.png";